import moment from 'moment';
const Format = {
    fromDatePicker(dateFormat, date) {
        if (date) {
            if (moment(date, dateFormat, true).isValid()) {
                return date;
            }
            else {
                return moment(date, 'YYYY-MM-DD').format(dateFormat.toUpperCase());
            }
        }
        return undefined;
    },
    fromTimePicker(timeFormat, time) {
        if (time) {
            if (moment(time, timeFormat, true).isValid()) {
                return time;
            }
            else {
                return moment(time, 'hh:mm:ss').format(timeFormat);
            }
        }
        return undefined;
    },
    toJson(json) {
        if (typeof json === 'string') {
            return JSON.parse(json);
        }
        return json;
    },
    toMask(textFormat) {
        const mask = [];
        for (const character of textFormat) {
            switch (character) {
                case 'X':
                    mask.push(/[0-9a-zA-Z]/);
                    break;
                case '#':
                case '0':
                    mask.push(/\d/);
                    break;
                default:
                    mask.push(character);
                    break;
            }
        }
        return mask;
    },
    toPhone(value, format, formatChar) {
        if (format && value && formatChar) {
            let formattedNumber = '';
            let iNumber = 0;
            for (const fChar of format) {
                if (fChar === formatChar) {
                    if (iNumber < value.length) {
                        formattedNumber = `${formattedNumber}${value[iNumber]}`;
                        iNumber++;
                    }
                }
                else {
                    formattedNumber = `${formattedNumber}${fChar}`;
                }
            }
            if (iNumber < value.length) {
                for (let iRest = iNumber; iRest < value.length; iRest++) {
                    formattedNumber = `${formattedNumber}${value[iRest]}`;
                }
            }
            return formattedNumber;
        }
        else {
            return value;
        }
    },
    toDatePicker(dateFormat, date) {
        if (date) {
            if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
                return date;
            }
            else {
                return moment(date, dateFormat.toUpperCase()).format('YYYY-MM-DD');
            }
        }
        return undefined;
    },
    toString(format, args) {
        return format.replace(/{(\d+)}/g, (_match, value) => (typeof args[value] !== 'undefined') && args[value] !== null ? args[value] : '');
    },
    toSumRem(rem) {
        let result = 0;
        rem.forEach(value => result += Number(value.replace('rem', '')));
        return `${result}rem`;
    }
};
export default Format;
